import React from 'react';
import Typography from '@mui/material/Typography';

import { useMediaTableContext } from '../../../hooks';

export const VpSubmissionsSelectedCount = () => {
  const { getSelectedMediaCount } = useMediaTableContext();
  const count = getSelectedMediaCount();

  if (!count) {
    return null;
  }

  const label = count === 1 ? 'item' : 'items';

  return (
    <Typography sx={{mr: '12px'}}>
      {count} {label} selected
    </Typography>
  );
};

export default VpSubmissionsSelectedCount;



// WEBPACK FOOTER //
// ./src/vp-ui/components/CampaignSubmissions/VpSubmissionsSelectedCount.jsx